import { NextPageWithLayout } from 'next';
import React from 'react';
import { useIntl } from 'react-intl';
import { Grid, GridCell } from '@fuww/library/src/Grid';
import { Breadcrumbs } from '@fuww/library/src/Breadcrumb';
import withApollo from '../lib/apollo';
import Head from '../components/Head';
import Layout from '../components/Layout';
import NewsletterForm from '../components/NewsletterForm';
import messages from '../lib/messages.json';
import HomeLink from '../components/HomeLink';
import LinkAndAnchor from '../components/LinkAndAnchor';
import Hero from '../components/Hero';
import { CaptchaProvider } from '../components/Captcha';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/mrAF4HFb5c_YqP-tWmv5ivT2YqMqkGhBMzz_tfuHGrw/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9oZXJvLzIwMjMvbmV3c2xldHRlcl9oZXJvX2ltYWdlLnBuZw',
    'https://r.fashionunited.com/HqzX5UWkCSn2xHZZ2I0gJRLI58HxkzGqma2_8zMIYb8/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9oZXJvLzIwMjMvbmV3c2xldHRlcl9oZXJvX2ltYWdlLnBuZw',
    'https://r.fashionunited.com/zELGGmbn2jZ4icMi4bHd8qZEg1IS7fj-MjowvdzY2Es/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9oZXJvLzIwMjMvbmV3c2xldHRlcl9oZXJvX2ltYWdlLnBuZw',
  ],
  desktop: [
    'https://r.fashionunited.com/-wot_A_nsnnz5_xo2Pf2l28Kr8W40n-8JM_HrD9EQoQ/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9oZXJvLzIwMjMvbmV3c2xldHRlcl9oZXJvX2ltYWdlLnBuZw',
    'https://r.fashionunited.com/K0UCQf0fRpDeJa7jliGdF6is2drxNjU6pIIVyx1WXP8/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9oZXJvLzIwMjMvbmV3c2xldHRlcl9oZXJvX2ltYWdlLnBuZw',
    'https://r.fashionunited.com/cD769NwDvplLZX4tZjL5MZYHDBmk-fQSWJ-S-yW-730/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9oZXJvLzIwMjMvbmV3c2xldHRlcl9oZXJvX2ltYWdlLnBuZw',
    'https://r.fashionunited.com/Ww0HQLwupA85fV2hwLu1pm_Sp88HvnkDpoQVJ5bToJI/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9oZXJvLzIwMjMvbmV3c2xldHRlcl9oZXJvX2ltYWdlLnBuZw',
  ],
};

const NewsletterPage: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="newsletter"
      passHref
    >
      {intl.formatMessage(messages.newsletter)}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages.newsletterMetaTitle)}
        description={intl.formatMessage(messages.newsletterMetaDescription)}
      />
      <Layout
        header={(
          <Hero
            imageUrls={headerImageUrls}
            alt="FashionUnited newsletter banner image"
          />
    )}
      >
        <Grid>
          <GridCell padding="24px">
            <Breadcrumbs
              crumbs={breadcrumbs}
            />
          </GridCell>
          <GridCell padding="24px">
            <CaptchaProvider>
              <NewsletterForm />
            </CaptchaProvider>
          </GridCell>
        </Grid>
      </Layout>
    </>
  );
};
NewsletterPage.getLayout = (page) => page;

export default withApollo(NewsletterPage);
